function extendHeadersWithToken(headers, idToken) {
    if (typeof idToken !== "undefined" && idToken != null) {
        headers["Authorization"] = "Bearer " + idToken;
    }
}

class InvalidAuthTokenException extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}

function makeGenericApiRequest(method, url, params, rawBody, successCallback, errorCallback, context, idToken, expectJson) {
    if (method !== "GET" && method !== "POST") {
        throw "unsupported http method " + method;
    }
    if (idToken == null) {
        throw new InvalidAuthTokenException("no auth token is provided");
    }
    let headers = {};
    if (method == "POST") {
       headers["Content-Type"] = "application/json";
    }
    extendHeadersWithToken(headers, idToken);
    let fetchParams = {
        method: method,
        headers: headers,
    };
    if (method == "POST") {
        if (rawBody != null) {
            fetchParams["body"] = rawBody;
        } else {
            fetchParams["body"] = JSON.stringify(params);
        }
    }
    fetch(url, fetchParams)
        .then((response) => {
            if (response.ok) {
                if (expectJson)
                    successCallback(context, response.json());
                else
                    successCallback(context, response.text());
            } else {
                errorCallback(context, response.text());
            }
        });
}

function makeGetApiRequest(url, successCallback, errorCallback, context, idToken, expectJson) {
    makeGenericApiRequest("GET", url, null, null, successCallback, errorCallback, context, idToken, expectJson);
}

function makeJsonApiRequest(url, params, successCallback, errorCallback, context, idToken, expectJson) {
    makeGenericApiRequest("POST", url, params, null, successCallback, errorCallback, context, idToken, expectJson);
}

function makePostRawBodyRequest(url, rawBody, successCallback, errorCallback, context, idToken, expectJson) {
    makeGenericApiRequest("POST", url, null, rawBody, successCallback, errorCallback, context, idToken, expectJson);
}

function makePostNoBodyRequest(url, successCallback, errorCallback, context, idToken, expectJson) {
    if (idToken == null) {
        throw new InvalidAuthTokenException("no auth token is provided");
    }
    let headers = {};
    extendHeadersWithToken(headers, idToken);
    let fetchParams = {
        method: "POST",
        headers: headers,
    };
    fetch(url, fetchParams)
        .then((response) => {
            if (response.ok) {
                if (expectJson)
                    successCallback(context, response.json());
                else
                    successCallback(context, response.text());
            } else {
                errorCallback(context, response.text());
            }
        });
}

/* copied from https://stackoverflow.com/a/111545 */
function encodeQueryData(data) {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
}

function makeSuggestRequest(lastEntered, successCallback, errorCallback, context) {
    const query = encodeQueryData({part: lastEntered});
    const url = `/suggest?${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function makeDetectRequest(lastEntered, suggest, successCallback, errorCallback, context) {
    const params = {
        q: lastEntered,
    };
    if (suggest) {
        params["suggest"] = "1";
    }
    const query = encodeQueryData(params);
    const url = `/detect?${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function makeAnalyzeRequest(lastEntered, successCallback, errorCallback, context) {
    const query = encodeQueryData({q: lastEntered});
    const url = `/analyze?${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function makeAnalyzeSubRequest(wordsRawBody, successCallback, errorCallback, context) {
    const url = "/analyze_sub";
    makePostRawBodyRequest(url, wordsRawBody, successCallback, errorCallback, context, "lala", true);
}

function loadTopList(successCallback, errorCallback) {
    const url = `/present_top100_ru_en.colonsv`;
    makeGetApiRequest(url, successCallback, errorCallback, null, "lala", false);
}

function probeVideo(onlineVideoId, successCallback, errorCallback) {
    const url = `/qarauapi/v1/probe/${onlineVideoId}`;
    makeGetApiRequest(url, successCallback, errorCallback, null, "lala", true);
}

function fetchVideo(internalId, successCallback, errorCallback) {
    const url = `/qarauapi/v1/fetch/${internalId}`;
    makePostNoBodyRequest(url, successCallback, errorCallback, null, "lala", true);
}

function loadSubtitles(transcriptionId, query, successCallback, errorCallback, context) {
    const queryStr = encodeQueryData(query);
    const url = `/qarauapi/v1/subtitles/${transcriptionId}?${queryStr}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function loadBreakdowns(transcriptionId, query, successCallback, errorCallback, context) {
    const queryStr = encodeQueryData(query);
    const url = `/qarauapi/v1/breakdowns/${transcriptionId}?${queryStr}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function enqueueBreakdowns(params, successCallback, errorCallback, context) {
    const url = `/qarauapi/v1/breakdowns/enqueue`;
    makeJsonApiRequest(url, params, successCallback, errorCallback, context, "lala", true);
}

function loadTopics(successCallback, errorCallback, context) {
    const url = `/qarauapi/v1/topics`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function loadVideosOnTopics(topics, successCallback, errorCallback, context) {
    const query = encodeQueryData({ topics: topics.join(",") });
    const url = `/qarauapi/v1/videos_on_topics?${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function searchTranscriptions(query, successCallback, errorCallback, context) {
    const queryStr = encodeQueryData({ q: query });
    const url = `/qarauapi/v1/transcriptions/search?${queryStr}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function searchInTranscription(transcriptionId, query, successCallback, errorCallback, context) {
    const queryStr = encodeQueryData({ q: query });
    const url = `/qarauapi/v1/transcription/${transcriptionId}/search?${queryStr}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

function loadSuggestedPlaylists(cursor, successCallback, errorCallback, context) {
    const query = cursor === "" ? "" : `?${encodeQueryData({ cursor })}`;
    const url = `/qarauapi/v1/suggested_playlists${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

// `videoId` is optional: without it the response carries just the page of items
// and its paging tokens (no cur_video)
function loadPlaylistPage(playlistId, videoId, pageToken, successCallback, errorCallback, context) {
    const query = encodeQueryData({ v: videoId, page: pageToken });
    const url = `/qarauapi/v1/playlist/${playlistId}?${query}`;
    makeGetApiRequest(url, successCallback, errorCallback, context, "lala", true);
}

export {
    InvalidAuthTokenException,
    makeGetApiRequest,
    makeJsonApiRequest,
    makePostNoBodyRequest,
    encodeQueryData,
    makeSuggestRequest,
    makeDetectRequest,
    makeAnalyzeRequest,
    makeAnalyzeSubRequest,
    loadTopList,
    probeVideo,
    fetchVideo,
    loadSubtitles,
    loadBreakdowns,
    enqueueBreakdowns,
    loadTopics,
    loadVideosOnTopics,
    loadSuggestedPlaylists,
    loadPlaylistPage,
    searchTranscriptions,
    searchInTranscription,
};
